var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.993,11a2,2,0,1,1,2-2A2.006,2.006,0,0,1,5.993,11ZM14,9a2,2,0,1,0-2,2A2.006,2.006,0,0,0,14,9Zm6.007,0a2,2,0,1,0-2,2A2.006,2.006,0,0,0,20.007,9Zm-4,6.006a2,2,0,1,0,2-2A2.006,2.006,0,0,0,16.007,15ZM14,15a2,2,0,1,0-2,2A2.006,2.006,0,0,0,14,15ZM7.993,15a2,2,0,1,0-2,2A2.006,2.006,0,0,0,7.993,15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorder);
export default __webpack_public_path__ + "static/media/reorder.3957d5da013fd3115f392b2b0567d5df.svg";
export { ForwardRef as ReactComponent };